<template>
  <div>
    <FilterOrganization :disable="false" @option="onOptionChange" :option="option"/>
    <Method_IDP class="mb-4" :item="item"/>
    <ReportCompetencyIDP class="mb-4" :item="status"/>

    <History icon="cil-speedometer" caption="Individual Development Plan" />


  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {CChartDoughnut} from '@coreui/vue-chartjs'
import FilterOrganization from "@/projects/components/Filter/FilterOrganization";
import History from "@/projects/views/E-Performances/Reports/components/Historys.vue";
import Method_IDP from "@/projects/views/E-Performances/Reports/components/Methods.vue";
import ReportCharts from "@/projects/views/E-Performances/Reports/components/ReportCharts.vue";
import ReportCompetencyIDP from "@/projects/views/E-Performances/Reports/components/ReportCompetencyIDP.vue";


export default {
  name: "RIDP",
  components: {ReportCompetencyIDP, ReportCharts, Method_IDP, History, FilterOrganization},

  props: {},
  data: function () {
    return {
      option: {
        organization: "66cbe802a41ed9362a8579fa",
        agency: 0,
        year: new Date().getFullYear() + 542,
      },
      loading: true,

      item: [],
      status: [],
      idpHistory: []

    }

  },

  mounted() {

  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      // this.onLoad();
    },

    onLoad() {
      var body = {};
      body.year = this.option.year;
      body.agency = this.option.agency;

      this.$store.dispatch("rMethod/config", body);
      this.$store.dispatch("report/status", body);
      this.$store.dispatch("report/members", body);
      this.onLoadStatus();
    },

    onOptionChange(e) {
      this.option = e;
      this.onLoad();
    },


    onLoadStatus() {
      // var body = {};
      // body.year = this.option.year;
      // if (this.option.agency !== 0) {
      //   body.agency = this.option.agency;
      // }
      // this.$store.dispatch("idpReport/status", body);
    },

    onChangeLanguage() {
      var lang = this.$store.getters["setting/lang"];
      this.item = [];
      this.status = [];
      this.idpHistory = [];

      this.item = this.reportMethod.map(item => ({
        title: item.title.filter(objs => { return objs.key === lang })[0].value,
        value: item.value,
      })).sort((a, b) => b.value - a.value)

      this.status =  this.rStatus.map(item => ({
        title: item.title.filter(objs => { return objs.key === lang })[0].value,
        value: item.value,
        total: item.total,
        // completed: item.completed,
        // progress: item.progress,

        history: item.historys.map(history => ({
          ...history,
          accounts:history.accounts.accounts.userinfo.prefix.filter(objs => { return objs.key === lang })[0].value+' '+history.accounts.accounts.userinfo.firstName.filter(objs => { return objs.key === lang })[0].value+' '+history.accounts.accounts.userinfo.lastName.filter(objs => { return objs.key === lang })[0].value,
          assessor:history.assessor.accounts.accounts.userinfo.prefix.filter(objs => { return objs.key === lang })[0].value+' '+history.assessor.accounts.accounts.userinfo.firstName.filter(objs => { return objs.key === lang })[0].value+' '+history.assessor.accounts.accounts.userinfo.lastName.filter(objs => { return objs.key === lang })[0].value,

          state:history.status.at(-1).state.title.filter(objs => { return objs.key === lang })[0].value,
          status:history.status.at(-1).state,
        })),

        pending : item.historys.filter( item => { return (item.status.at(-1).state._id.toString() === "654851a37ab25be71bbeeed6") }).length,
        completed : item.historys.filter( item => { return (item.status.at(-1).state._id.toString() === "67bfc7ed24e13ba338b58e4d") }).length,
        progress : item.historys.filter( item => { return (item.status.at(-1).state._id.toString() !== "654851a37ab25be71bbeeed6" && item.status.at(-1).state._id.toString() !== "67bfc7ed24e13ba338b58e4d") }).length,



      }))

      // this.idpHistory = value.map(item => ({
      //   id: item._id,
      //   code: item.accounts.accounts.code,
      //   position: item.position.agency.title.find(t => t.key === 'th').value,
      //   info: item.accounts.accounts.userinfo.prefix.find(t => t.key === 'th').value + " " + item.accounts.accounts.userinfo.firstName.find(t => t.key === 'th').value + " " + item.accounts.accounts.userinfo.lastName.find(t => t.key === 'th').value,
      //   status: item.status.at(-1).state.title.find(t => t.key === 'th').value,
      //   isTalent: item.isTalent,
      //   assessor: item.assessor.accounts.accounts.userinfo.prefix.find(t => t.key === 'th').value + " " + item.assessor.accounts.accounts.userinfo.firstName.find(t => t.key === 'th').value + " " + item.assessor.accounts.accounts.userinfo.lastName.find(t => t.key === 'th').value,
      // }));
    }
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      reportStatus: "idpReport/item",
      reportMethod: "rMethod/item",
      rStatus: "report/status",
    }),

  },

  watch: {
    lang(value){
      this.onChangeLanguage(value)
    },
    reportStatus(value) {
      this.onChangeLanguage();
      this.loading = false;
    },

    reportMethod(value){
      this.onChangeLanguage();
    },

    rStatus(value){
      this.onChangeLanguage();
    },



  }

}
</script>

<style scoped>

</style>
